/**
 * Convierte un arreglo de proyectos al formato de opciones 
 * compatible con los componentes de Dropdown.
 */

// Eliminadas las interfaces Project y Option

export function formatProjectsToOptions(data) {
  // Verificamos que data exista y sea un arreglo
  if (!data || !Array.isArray(data)) return [];
  
  return data.map((project) => ({
    label: project.name,
    value: project.id,
  }));
}